import React, { useState, useEffect } from 'react'
import {
  ValidatorForm,
  TextValidator,
  SelectValidator
} from 'react-material-ui-form-validator'
import { CircularProgress, Grid } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import DropzoneS3Uploader from 'react-dropzone-s3-uploader'
import ModalInc from '../../../shared-ui/ModalInc'
import { useStyle } from './Style'
import ButtonInc from '../../../shared-ui/ButtonInc'
import AlertDialog from '../../AlertDialog/index.es6'
import { getPartnerGuid, getUserFullname } from '../../../lib/access.es6'
import ProgressState from './ProgressState'
import { getSignedUrlForAnyBucket } from '../../../lib/requests.es6'
import { AppConfigs } from '../../../lib/configs'

const AddGuide = props => {
  const classes = useStyle()

  const [title, setTitle] = useState('')
  const [type, setType] = useState('')
  const [description, setDescription] = useState('')
  const [url, setUrl] = useState('')
  const [showUploadPdf, setShowUploadPdf] = useState(false)
  const [s3Url] = useState('https://puplic-assets.s3.amazonaws.com')
  const [progress, setProgress] = useState(0)
  const [errorMessage, setErrorMessage] = useState(null)
  const [isUploading, setIsUploading] = useState(false)

  useEffect(function() {
    if (props.showAddGuideSuccessAlert) {
      props.close()
      props.resetAddGuideSuccess()
    }
  }, [props.showAddGuideSuccessAlert])

  const saveTemplate = (overrideUrl) => {
    const payload = {
      title,
      type,
      description,
      url: overrideUrl !== undefined ? overrideUrl : url,
      created_by: getUserFullname(),
      updated_by: getUserFullname(),
      partner: getPartnerGuid(),
      status: 'UP_TO_DATE'
    }
    props.saveGuide(payload)
  }

  const handleChange = event => {
    const { name, value } = event.target
    if (name === 'title') setTitle(value)
    if (name === 'description') setDescription(value)
    if (name === 'type') {
      setType(value)
      setShowUploadPdf(value === 'PDF')
    }
    if (name === 'url') setUrl(value)
  }

  const handleFinishedUpload = info => {
    const uploadedUrl = info.fileUrl.replace('undefined', info.bucketKey)
    setUrl(uploadedUrl)
    setIsUploading(false)
    saveTemplate(uploadedUrl)
  }

  const getS3Ur = (file, callback) =>
    getSignedUrlForAnyBucket(
      file,
      callback,
      AppConfigs.REACT_APP_AWS_KNOWLEDGE_BASE_S3_BUCKET_NAME
    )

  const uploadOptions = {
    getSignedUrl: getS3Ur,
    s3Url,
    uploadRequestHeaders: {},
    onProgress: p => {
      setProgress(p)
      if (p > 0 && p < 100) setIsUploading(true)
    },
    onError: msg => setErrorMessage(msg)
  }

  const isLoading = props.showAddGuideProgressAlert
  const isDisabled = isLoading || isUploading

  return (
    <>
      <AlertDialog
        show={props.showAddGuideErrorAlert}
        danger
        title="Error adding guide"
        confirmBtnText="Try again"
        confirmBtnCssClass
        showCancel={false}
        showConfirm={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {props.AddGuideError ? props.AddGuideError.message : ''}
        <div>
          <ButtonInc
            variant="contained"
            onClick={props.resetAddGuideError}
            style={{ background: 'green' }}
          >
            OK
          </ButtonInc>
        </div>
      </AlertDialog>

      <ModalInc
        modalTitle="Lets make a new guide"
        subTitle="Fill the below fields to create a guide"
        open={props.open}
        onClose={props.close}
        fullWidth
        maxWidth="md"
      >
        <ValidatorForm onSubmit={() => {}}>
          <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <TextValidator
                  name="title"
                  id="title"
                  label="Title"
                  value={title}
                  onChange={handleChange}
                  fullWidth
                  className={classes.paymentinputs}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter the title']}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <TextValidator
                  name="description"
                  id="description"
                  label="short description"
                  value={description}
                  onChange={handleChange}
                  fullWidth
                  className={classes.paymentinputs}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter a short description']}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <SelectValidator
                  label="Type"
                  name="type"
                  value={type}
                  onChange={handleChange}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please select type']}
                  style={{ marginBottom: '10px', width: '100%' }}
                >
                  {['SCRIBE', 'VIDEO', 'PDF'].map(t => (
                    <MenuItem
                      key={t}
                      sx={{
                        fontFamily: 'Open Sans',
                        fontStyle: 'normal',
                        fontWeight: 300,
                        fontSize: '12px',
                        lineHeight: '16px',
                        letterSpacing: '0.005em',
                        color: '#000000'
                      }}
                      value={t}
                    >
                      {t}
                    </MenuItem>
                  ))}
                </SelectValidator>
              </Grid>

              {showUploadPdf ? (
                <Grid item xs={12} sm={12} md={12}>
                  <div className={classes.uploadsection}>
                    <DropzoneS3Uploader
                      onFinish={handleFinishedUpload}
                      upload={uploadOptions}
                      s3Url={s3Url}
                      passChildrenProps={false}
                      maxSize={1024 * 1024 * 5}
                      className={classes.uploadzone}
                      style={{
                        width: '100%',
                        height: '200px',
                        background: '#FFFFFF',
                        border: '1px dashed #B8B8B8',
                        padding: '55px 0'
                      }}
                    >
                      <div>
                        <ProgressState
                          progress={progress}
                          errorMessage={errorMessage}
                        />
                      </div>
                    </DropzoneS3Uploader>
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} sm={12} md={12}>
                  <TextValidator
                    name="url"
                    id="url"
                    label="Resource Url"
                    value={url}
                    onChange={handleChange}
                    fullWidth
                    className={classes.paymentinputs}
                    variant="outlined"
                    validators={['required']}
                    errorMessages={['Please enter resource URL']}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <ButtonInc
                variant="contained"
                color="primary"
                size="large"
                onClick={props.close}
                disabled={isDisabled}
                style={{
                  width: '221px',
                  height: '55px',
                  background: '#9e9e9e',
                  marginTop: '10%',
                  border: '1px solid #FBA92D'
                }}
              >
                Cancel
              </ButtonInc>
            </Grid>
            {!showUploadPdf && (
              <Grid item>
                <ButtonInc
                  size="large"
                  onClick={() => saveTemplate()}
                  variant="contained"
                  disabled={isDisabled}
                  style={{ width: '221px', height: '55px', marginTop: '10%' }}
                >
                  {isLoading ? (
                    <>
                      <CircularProgress size={18} style={{ color: '#fff', marginRight: 8 }} />
                      Saving...
                    </>
                  ) : 'Save Guide'}
                </ButtonInc>
              </Grid>
            )}
          </Grid>
        </ValidatorForm>
      </ModalInc>
    </>
  )
}

export default AddGuide
